
 export const passwordPattern = '^(?=.*)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])[^ ]{8,32}$';
 export const vatIdPattern = '^[a-zA-Z0-9]{5,15}$';
